import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {toast} from 'react-toastify';

import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {ShopifyLogo} from "../../logos/ShopifyLogo";
import {Spinner} from "../../Spinner";
import './ConnectShopifyClientModal.scss';


class ConnectShopifyClientModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            clients: null,            // lista de clientes de la agencia (null = cargando)
            selectedClientId: '',
            loadingCode: false,
            errorLoading: false,
            code: null,               // código generado para el cliente elegido
        };
        this.toggle = this.toggle.bind(this);
        this.handleClientChange = this.handleClientChange.bind(this);
    }

    toggle() {
        const willOpen = !this.state.modal;
        this.setState({modal: willOpen});
        if (willOpen && this.state.clients === null) {
            this._fetchClients();
        }
    }

    _fetchClients() {
        new APIClient(API_URL + 'agency/clients/')
            .call('GET')
            .then((response) => {
                this.setState({clients: (response && response.data) || []});
            })
            .catch(() => this.setState({clients: []}));
    }

    handleClientChange(event) {
        const clientId = event.target.value;
        // Al cambiar de cliente reseteamos el código mostrado y, si hay cliente, generamos el suyo.
        this.setState({selectedClientId: clientId, code: null, errorLoading: false});
        if (clientId) {
            this._generateForClient(clientId);
        }
    }

    _generateForClient(clientId) {
        this.setState({loadingCode: true, errorLoading: false, code: null});
        new APIClient(API_URL + 'agency/shopify/connection-codes/generate/')
            .call('POST', {agency_client_id: clientId})
            .then((response) => {
                if (response && response.status === 'OK') {
                    this.setState({code: response.data, loadingCode: false});
                } else {
                    this.setState({loadingCode: false, errorLoading: true});
                }
            })
            .catch(() => this.setState({loadingCode: false, errorLoading: true}));
    }

    _copyToClipboard(text, successKey) {
        const {t} = this.props;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(
                () => toast.success(t(successKey)),
                () => toast.error(t('connect_shopify_client_modal.copy_failed'))
            );
        }
    }

    _whatsappMessage(code) {
        return this.props.t('connect_shopify_client_modal.whatsapp_template', {
            install_link: code.install_link,
            code: code.code,
        });
    }

    render() {
        const {t} = this.props;
        const {modal, clients, selectedClientId, loadingCode, errorLoading, code} = this.state;

        return (
            <Modal isOpen={modal} toggle={this.toggle} size="lg" backdrop="static" className="connect-shopify-client-modal">
                <ModalHeader toggle={this.toggle}>
                    <ShopifyLogo/>&nbsp;{t('connect_shopify_client_modal.title')}
                </ModalHeader>
                <ModalBody>
                    <div className="modal-section">
                        <p className="connect-shopify-client-intro">
                            {t('connect_shopify_client_modal.intro')}
                        </p>

                        <div className="connect-shopify-client-step">
                            <label className="connect-shopify-client-step-label">
                                {t('connect_shopify_client_modal.client_label')}
                            </label>
                            <select
                                className="form-control"
                                value={selectedClientId}
                                onChange={this.handleClientChange}
                                disabled={clients === null}
                            >
                                <option value="">
                                    {clients === null
                                        ? t('connect_shopify_client_modal.client_loading')
                                        : t('connect_shopify_client_modal.client_placeholder')}
                                </option>
                                {(clients || []).map((c) => (
                                    <option key={c.id} value={c.id}>{c.name}</option>
                                ))}
                            </select>
                            <p className="connect-shopify-client-step-hint">
                                {t('connect_shopify_client_modal.client_hint')}
                            </p>
                        </div>

                        {loadingCode && (
                            <div className="connect-shopify-client-loader">
                                <Spinner color="positive"/>
                                <span>{t('connect_shopify_client_modal.loading')}</span>
                            </div>
                        )}

                        {errorLoading && (
                            <p className="connect-shopify-client-error">
                                {t('connect_shopify_client_modal.error_loading')}
                            </p>
                        )}

                        {!loadingCode && !errorLoading && code && (
                            <>
                                <div className="connect-shopify-client-step">
                                    <label className="connect-shopify-client-step-label">
                                        {t('connect_shopify_client_modal.step1_label')}
                                    </label>
                                    <div className="connect-shopify-client-row">
                                        <input
                                            type="text"
                                            className="form-control"
                                            readOnly
                                            value={code.install_link}
                                        />
                                        <Button color="secondary" onClick={() => this._copyToClipboard(code.install_link, 'connect_shopify_client_modal.copied_link')}>
                                            {t('connect_shopify_client_modal.copy_link')}
                                        </Button>
                                    </div>
                                    <p className="connect-shopify-client-step-hint">
                                        {t('connect_shopify_client_modal.step1_hint')}
                                    </p>
                                </div>

                                <div className="connect-shopify-client-step">
                                    <label className="connect-shopify-client-step-label">
                                        {t('connect_shopify_client_modal.step2_label')}
                                    </label>
                                    <div className="connect-shopify-client-row">
                                        <input
                                            type="text"
                                            className="form-control connect-shopify-client-code"
                                            readOnly
                                            value={code.code}
                                        />
                                        <Button color="secondary" onClick={() => this._copyToClipboard(code.code, 'connect_shopify_client_modal.copied_code')}>
                                            {t('connect_shopify_client_modal.copy_code')}
                                        </Button>
                                    </div>
                                    <p className="connect-shopify-client-step-hint">
                                        {t('connect_shopify_client_modal.step2_hint')}
                                    </p>
                                </div>

                                <div className="connect-shopify-client-whatsapp">
                                    <button
                                        type="button"
                                        className="btn -alt"
                                        onClick={() => this._copyToClipboard(this._whatsappMessage(code), 'connect_shopify_client_modal.copied_message')}
                                    >
                                        {t('connect_shopify_client_modal.copy_whatsapp')}
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.toggle}>
                        {t('connect_shopify_client_modal.close')}
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export const ConnectShopifyClientModal = withTranslation()(ConnectShopifyClientModalClass);
export default ConnectShopifyClientModal;
